import React from 'react';
import { DealQueueFilter } from 'client/modules/news/queue/components/DealQueueFilter';
import { DealCard as DealCardModel } from 'client/modules/news/queue/apis/GetDealQueue';
import { DealFilterOption } from 'client/modules/news/queue/apis/GetDealFilterOptions';
import DealQueueList from './DealQueueList';

interface DealQueueData {
  dealCards?: DealCardModel[];
  totalCount?: number;
  isLoading?: boolean;
}

interface DealQueueProps {
  dealData: DealQueueData;
  handleSubmit: () => void;
  handleClear: () => void;
  languageOptions?: DealFilterOption[];
}

export const DealQueue = ({
  dealData,
  handleSubmit,
  handleClear,
  languageOptions = [],
}: DealQueueProps) => {
  const { dealCards = [], totalCount = 0, isLoading = false } = dealData;

  return (
    <React.Fragment>
      <div className="flex flex-row justify-between mb-8 border-b-2 border-gray-300 items-center">
        <div className="w-40 shrink-0 pr-2 text-sm text-gray-700">
          {dealCards.length} deal{dealCards.length === 1 ? '' : 's'} in your
          queue
          {totalCount > 0 ? ` · ${totalCount} more available` : ''}
        </div>
        <div className="flex-1 min-w-0">
          <DealQueueFilter
            handleSubmit={handleSubmit}
            handleClear={handleClear}
            queueCount={dealCards.length}
            isLoading={isLoading}
            languageOptions={languageOptions}
          />
        </div>
      </div>
      <DealQueueList dealCards={dealCards} isLoading={isLoading} />
    </React.Fragment>
  );
};
